export default __webpack_public_path__ + "static/media/security.d92d3744.svg";